import { CommonFunctions } from "../static/common-functions";
import { DispatchNoteBus } from "./DispatchNoteBus";
import { v_DispatchAttachmentBus } from "./v_DispatchAttachmentBus";
import { v_DispatchEquipmentSvcdBus } from "./v_DispatchEquipmentSvcdBus";
import { DispatchAssignmentBus } from './DispatchAssignmentBus';
import { DispatchLaborBus } from './DispatchLaborBus';
import { DispatchPartsRequestedBus } from './DispatchPartsRequestedBus';
import { DQOIErrorBus } from "./DQOIError";
import { DispatchCustPartsBus } from "./DispatchCustPartsBus";
import { CnstJobBus } from "./CnstJobBus";     
import { DispatchContAdjustmentBus } from "./DispatchContAdjustmentBus";
import { DispatchCostAdjustmentBus } from "./DispatchCostAdjustmentBus";
import { DispatchCurrCostAdjustmentBus } from "./DispatchCurrCostAdjustmentBus";
import { DispatchBTDAdjustmentBus } from "./DispatchBTDAdjustmentBus";
import { DispatchSixZeroSixAdjustmentBus } from "./DispatchSixZeroSixAdjustmentBus";
import { DispatchPartsBus } from "./DispatchPartsBus";
import { DispatchRefTrackingBus } from "./DispatchRefTrackingBus";

export class CnstJobSaveParam extends CnstJobBus {
    constructor(data: CnstJobBus) {
        super(data);
    }
    notes: DispatchNoteBus[];
    assignments: DispatchAssignmentBus[];
    attachments: v_DispatchAttachmentBus[];
    equipment: v_DispatchEquipmentSvcdBus[];
    partsReq: DispatchPartsRequestedBus[];
    parts: DispatchPartsBus[];
    labor: DispatchLaborBus[];
    contAdjustments: DispatchContAdjustmentBus[];
    costAdjustments: DispatchCostAdjustmentBus[];
    currCostAdjustments: DispatchCurrCostAdjustmentBus[];
    btdAdjustments: DispatchBTDAdjustmentBus[];
    sixZeroSixAdjustments: DispatchSixZeroSixAdjustmentBus[];
    refTracking: DispatchRefTrackingBus[];
}
